document.addEventListener('DOMContentLoaded', function(){
  const faqSection = document.querySelector('.custom-offers-faq');
  if (!faqSection) return;

  // Copy code functionality
  const copyBtns = faqSection.querySelectorAll('.offer-action__copy');
  copyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const code = btn.previousElementSibling.textContent;
      navigator.clipboard.writeText(code);
      const original = btn.innerHTML;
      btn.textContent = "Copied!";
      setTimeout(() => btn.innerHTML = original, 1500);
    });
  });
});

